{
  "errorBoundary": {
    "title": "Something broke on this screen",
    "description": "Take a screenshot of this screen and send it to us. The technical details below point to exactly where it happened.",
    "stack": "Component / stack",
    "reload": "Reload",
    "goHome": "Back to home"
  },
  "auth": {
    "poweredBy": "Powered by <brand>Xtreed</brand>"
  },
  "student": {
    "collapseMenu": "Collapse menu",
    "expandMenu": "Expand menu",
    "openMenu": "Open menu",
    "defaultLevel": "Beginner",
    "xp": "{{value}} XP",
    "menu": "Menu",
    "nav": {
      "home": "Home",
      "courses": "Courses",
      "ranking": "Leaderboard",
      "community": "Community",
      "certificates": "Certificates",
      "profile": "Profile"
    },
    "comingSoon": "Coming soon",
    "logout": "Log out",
    "welcome": "<muted>Welcome back,</muted> <name>{{name}}</name>",
    "admin": "Admin",
    "lightMode": "Light mode",
    "darkMode": "Dark mode",
    "myProfile": "My profile"
  },
  "admin": {
    "badge": "Admin",
    "groups": {
      "overview": "Overview",
      "content": "Content",
      "commercial": "Sales",
      "community": "Community",
      "platform": "Platform"
    },
    "nav": {
      "dashboard": "Dashboard",
      "courses": "Courses",
      "modules": "Modules",
      "videos": "Videos",
      "categories": "Categories",
      "certificates": "Certificates",
      "accessGroups": "Access groups",
      "members": "Members",
      "customFields": "Profile fields",
      "surveys": "Surveys",
      "gamification": "Gamification",
      "videoUsage": "Video usage",
      "settings": "Settings"
    },
    "closeMenu": "Close menu",
    "collapseMenu": "Collapse menu",
    "expandMenu": "Expand menu",
    "openMenu": "Open menu",
    "backToApp": "Back to app",
    "logout": "Log out",
    "panelTitle": "Admin panel",
    "online": "Online",
    "assistant": {
      "open": "Open assistant",
      "close": "Collapse assistant",
      "banner": {
        "title": "Meet the Xtreed Assistant",
        "subtitle": "It builds courses, modules and lessons for you, writes descriptions and publishes everything to your members area. Just chat.",
        "dontShowAgain": "Don't show this again",
        "close": "Close",
        "seeNow": "See it now"
      }
    }
  }
}
